import { entryService } from '@/_services';
import { EventBus } from '@/event-bus';

const EMAIL_TYPES = {
  GMAIL: 'gmail',
  OUTLOOK: 'outlook',
};

export default {
  name: 'emailEngine',
  data() {
    return {
      authCode: '',
      scheduledTime: null,

      gmailAlreadyAuthed: false,
    };
  },
  mounted() {
    const mailType = this.getFeature('esp');
    if (mailType === EMAIL_TYPES.GMAIL) {
      this.initGmail();
    }
  },
  computed: {
    edit() {
      return this.$store.state.entries.item;
    },
    emailEngine() {
      const mailType = this.getFeature('esp');

      const gmailConfig = {
        name: 'Gmail',
        action: this.loginGmail,
        status: this.$store.state.entries.gmailStatus,
      };

      const outlookConfig = {
        name: 'Outlook',
        action: this.loginOutlook,
        status: this.$store.state.entries.outlookStatus,
      };

      const defaultConfig = {
        name: 'Email',
        action: this.send,
        status: this.$store.state.entries.emailStatus,
      };

      if (mailType === EMAIL_TYPES.GMAIL) {
        return gmailConfig;
      } else if (mailType === EMAIL_TYPES.OUTLOOK) {
        return outlookConfig;
      }

      return defaultConfig;
    },
    scheduleISO() {
      return this.scheduledTime ? this.scheduledTime.clone().toISOString() : null;
    },
  },
  methods: {
    /**
     * Init gmail - We ask permission at first so we can bypass the popup iPad blocker
     */
    initGmail() {
      entryService.checkGmailAuth().then((r) => {
        this.gmailAlreadyAuthed = r.data.already_authed;
      });
    },
    send_test() {
      this.$mixpanel.track('send_test', {
        account_id: this.$store.state.account.user.user.email,
        edit: this.$route.params.id,
      });
      this.$refs.form.validate()
        .then((success) => {
          if (!success) {
            return;
          }
          // Send test using current email engine
          this.confirm_test = false;
          this.emailEngine.action({
            test_email: this.test_email,
            test_first_name: this.test_first_name,
          });
        });
    },
    async dispatchGmail(payload) {
      await this.$store.dispatch('entries/sendGmail', {
        authCode: this.authCode,
        test_payload: payload,
        scheduleISO: this.scheduleISO,
      });
      this.authCode = null;
    },
    async loginGmail(payload = {}, postAuthAction = this.dispatchGmail) {
      /**
       * degt's note
       * this.gmailAlreadyAuthed is fetched at mounted see initGmail()
       * this was done like this because when chaining async call doesn't allow to open popups on ipad
       * */
      let authCode = null;
      if (!this.gmailAlreadyAuthed) {
        try {
          authCode = await this.$gAuth.getAuthCode();
          this.authCode = authCode;
        } catch (error) {
          EventBus.$emit('confirm', {
            title: 'Error',
            message: `There was an error sending through Gmail: ${error}.`,
            positiveText: 'OK',
            showCancel: false,
          });
          return;
        }
      }
      await postAuthAction(payload);
    },
    async sendOutlook(test_payload = {}) {
      const r = await entryService.checkOutlookAuth();
      if (!r.data.already_authed) {
        EventBus.$emit('confirm', {
          title: 'Error',
          message: 'There was an error sending through Outlook: Could not login to Outlook.',
          positiveText: 'OK',
          showCancel: false,
        });
        return;
      }
      await this.$store.dispatch('entries/sendOutlook', { test_payload, scheduleISO: this.scheduleISO });
    },
    async loginOutlook(payload = {}, postAuthAction = this.sendOutlook) {
      const r = await entryService.checkOutlookAuth();
      if (!r.data.already_authed) {
        const res = await entryService.getOutlookAuthUrl();
        window.addEventListener('storage', (event) => {
          if (event.storageArea === localStorage) {
            if (event.key === 'stylelab.outlookAuthenticated') {
              if (event.newValue === 'true') {
                postAuthAction(payload)
                  .then(() => localStorage.removeItem('stylelab.outlookAuthenticated'));
              }
            }
          }
        });
        window.open(res.data.url, '_blank',
          'width=960,height=640,toolbar=no,menubar=no,scrollbars=no,location=no,status=no');
      } else {
        console.log(postAuthAction, payload);
        postAuthAction(payload);
      }
    },
    send(test_payload = {}, postAuthAction = null) {
      this.$mixpanel.track('send_edit', {
        account_id: this.$store.state.account.user.user.email,
        edit: this.$route.params.id,
      });
      const isTest = Object.keys(test_payload)
        .length > 0;
      if (this.recipientsCount === 0 && !isTest) {
        EventBus.$emit('confirm', {
          title: 'Error',
          message: 'Please specify at least one recipient.',
          positiveText: 'OK',
        });
        return;
      }

      this.$store.dispatch('entries/sendEmail', { test_payload, scheduleISO: this.scheduleISO });
    },
  },
};
